import { render } from "./ProductDataContent.vue?vue&type=template&id=7b376ab0&scoped=true"
import script from "./ProductDataContent.vue?vue&type=script&lang=js"
export * from "./ProductDataContent.vue?vue&type=script&lang=js"

import "./ProductDataContent.vue?vue&type=style&index=0&id=7b376ab0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b376ab0"]])

export default __exports__